import API from "./API"

const fertInfoEndpoint = "/fertilizer-infos/"

const listAllFertilizer = () => API.get(fertInfoEndpoint)

export default {
  listAllFertilizer,
}
